import React, { memo } from 'react';

import { ConfirmationType } from '../../../models/confirmation/ConfirmationEntity';

import CatalogsConfirmationDialog from './CatalogsConfirmationDialog';
import { CommandConfirmationDialogProps } from './CommandConfirmationDialogContainer';
import DatasetConfirmationDialog from './DatasetConfirmationDialog';

const CommandConfirmationDialog = ({
  type,
  ...props
}: CommandConfirmationDialogProps): React.JSX.Element =>
  type === ConfirmationType.CATALOGS || type === ConfirmationType.HIERARCHY ? (
    <CatalogsConfirmationDialog {...props} />
  ) : (
    <DatasetConfirmationDialog {...props} />
  );

export default memo(CommandConfirmationDialog);
